var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"icon":"mdi-bullhorn-outline","title":_vm.$t('marketing'),"subtitle":_vm.$t('marketing_page_subtitle')}}),_c('div',{staticClass:"marketing-body"},[_c('div',{staticClass:"marketing-content"},[_c('finance-tab-promotions')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }